import { produce } from "immer";
import { tLinkBankAction, tLinkBankState, tUpdateModalShown } from "./types";
const kDefaultModalShownState: tLinkBankState = {
  rModalShown: false,
};

const handleUpdateModal = (state: tLinkBankState, action: tUpdateModalShown): tLinkBankState => {
  const { rModalShown } = action;
  state.rModalShown = rModalShown;
  return state;
};

export const BankLinkReducer = produce(
  (state: tLinkBankState = kDefaultModalShownState, action: tLinkBankAction): tLinkBankState => {
    switch (action.type) {
      case "UPDATE_MODAL_SHOWN":
        return handleUpdateModal(state, action);
      default:
        return state;
    }
  },
);
